import {
  Modal,
  Box,
  Grid,
  Typography,
  Button,
  IconButton,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useParams } from "react-router-dom";
import PageHeader from "../../components/ui/PageHeader";
import CustomTable from "../../components/ui/CustomTable";
import CustomGridHeaderCell from "../../components/ui/CustomGridHeaderCell";
import CustomInput from "../../components/ui/CustomInput";
import { useIntl } from "react-intl";
import { useEffect, useState } from "react";
import axios from "../../api/axiosClient";
import { useLoading } from "../../components/LoadingContext";
import { handleError, errorToast } from "../../services/serviceBase";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import BarcodeIcon from "../../components/ui/BarcodeIcon";
import Checkbox from "@mui/material/Checkbox";
import toast from "react-hot-toast";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import { useNavigate } from "react-router-dom";
import AttachmentBoxInQCModal from "../../components/Modals/AttachmentBoxInQCModal";

export default function BoxInQC(props) {
  const intl = useIntl();
  const { setLoading } = useLoading();
  const params = useParams();
  const { idReturnFileHead } = params;
  const navigate = useNavigate();

  const [columns, setColumns] = useState([]);
  const [boxInQCData, setBoxInQCData] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [boxInLabelling, setBoxInLabelling] = useState(false);
  const [checked, setChecked] = useState(true);
  const [scannedBox, setScannedBox] = useState({ Barcode: "", IsGen: false });
  const [boxGenButtonDisabled, setBoxGenButtonDisabled] = useState(false);
  const [selectedBoxInId, setSelectedBoxInId] = useState("");
  const [activeAttachment, setActiveAttachment] = useState("");
  const [returnFileKey, setReturnFileKey] = useState("");

  const [openModalAttachmentBoxInQC, setOpenModalAttachmentBoxInQC] =
    useState(false);

  const handleCloseModalAttachmentBoxInQC = () =>{
    setOpenModalAttachmentBoxInQC(false);
    setSelectedBoxInId("")
    setActiveAttachment("")
  }

  const handleClose = () => {
    props.handleCloseModal();
  };

  const handleOpenModalAttachment = (e, boxInId) => {
    setOpenModalAttachmentBoxInQC(true);
    setSelectedBoxInId(boxInId)
  };

  useEffect(() => {
    if (
      idReturnFileHead !== null &&
      idReturnFileHead !== undefined &&
      idReturnFileHead !== ""
    ) {
      getBoxInQCData();
      setScannedBox({ Barcode: "", IsGen: false });
      getReturnFileKey();
    }
  }, [props.openModal]);

  useEffect(() => {
    if (boxInQCData.length > 0) {
      getColumns();
      if (boxInQCData.some((x) => x.isGenericBox)) {
        setScannedBox({ Barcode: "", IsGen: false });
      }
    }
  }, [boxInQCData, boxInLabelling]);

  const getBoxInQCData = async () => {
    setLoading(true);
    axios
      .get(`/returnfiles/${idReturnFileHead}/boxinqc`)
      .then((response) => {
        setLoading(false);
        
        const data = response.data.map((item, index) => {
          return {
            ...item,
            isTemp: false,
          };
        });

        setBoxInQCData(data);

        let initData = data.map((item) => {
          return { ...item };
        });
        setInitialData(initData);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getReturnFileKey = async () => {
    setLoading(true);
    axios
      .get(`/returnfiles/${idReturnFileHead}/returnfilekey`)
      .then((response) => {
        setLoading(false);
        setReturnFileKey(response.data.returnFileKey)
        
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const saveOrUpdateBoxInQC = async () => {
    let model = boxInQCData;
    setLoading(true);
    let url = `/returnfiles/${idReturnFileHead}/boxinqc`;
    axios
      .post(url, model)
      .then((response) => {
        setLoading(false);
        toast.success("Saved!");
        navigate(`${process.env.PUBLIC_URL}/QCDetail/${idReturnFileHead}`);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleGoBack = () => {
    if (!areDatasetEquals(initialData, boxInQCData)) {
      var message = intl.formatMessage({ id: "BoxKO.ConfirmGoBack" });
      if (!window.confirm(message)) {
        return false;
      }
    } else if (boxInQCData.map((x) => x.isTemp).some((x) => x == true)) {
      var message = intl.formatMessage({ id: "BoxKO.ConfirmGoBack" });
      if (!window.confirm(message)) {
        return false;
      }
    }
    navigate(`${process.env.PUBLIC_URL}/QCDetail/${idReturnFileHead}`);
  };

  const getGenericBoxId = async () => {
    setLoading(true);
    axios
      .get(`/returnfiles/boxinqc/boxinid`)
      .then((response) => {
        setLoading(false);
        setScannedBox({ Barcode: response.data, IsGen: true });
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  useEffect(() => {
    if (scannedBox.IsGen) {
      addRowInBoxIdQCDataset();
    }
  }, [scannedBox]);

  const addRowInBoxIdQCDataset = async () => {
    let newRow = {
      boxInId: scannedBox.Barcode,
      boxInQuantity: 1,
      boxInLabelling: scannedBox.IsGen,
      boxInDimensions: false,
      boxInWeight: false,
      boxInIntegrity: false,
      boxInContent: false,
      isGenericBox: scannedBox.IsGen,
      isTemp: true,
    };

    var newData = [...boxInQCData, newRow];
    setBoxInQCData(newData);
    setScannedBox({ Barcode: "", IsGen: false });
  };

  const handleDeleteRow = (boxInId, isTemp, isGen) => {
    var message = intl.formatMessage({ id: "BoxKO.Confirm" });
    if (!window.confirm(message)) {
      return false;
    }
    setLoading(true);
    if (isTemp) {
      let newDataset = [...boxInQCData];
      var item = newDataset.find((x) => x.boxInId == boxInId);
      if (item != null && item != undefined) {
        let idx = newDataset.indexOf(item);
        newDataset.splice(idx, 1);
        setBoxInQCData(newDataset);
      }
    } else {
      deleteRow(boxInId);
    }
    setLoading(false);
  };

  const deleteRow = (boxInId) => {
    axios
      .delete(`/returnfiles/${idReturnFileHead}/boxinqc/${boxInId}`)
      .then((response) => {
        setLoading(false);
        toast.success("Deleted!");
        window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleBarcodeFilterChange = (barcode) => {
    if (barcode.includes("<") || barcode.includes(">")) {
      return;
    } else {
      setScannedBox({ Barcode: barcode, IsGen: false });
    }
  };

  function RenderCheckBox(props) {
    const [checked, setChecked] = useState(props.value);
    const [isReadonly, setIsReadonly] = useState(
      props.field == "boxInLabelling"
    );

    const handleChange = (event) => {
      setChecked(event.target.checked);
      let newDataset = [...boxInQCData];
      var item = newDataset.find((x) => x.boxInId == props.row.boxInId);
      item[props.field] = event.target.checked;
      setBoxInQCData(newDataset);
    };

    return (
      <Checkbox
        checked={checked}
        onChange={handleChange}
        disabled={isReadonly}
        className="hideHover"
      />
    );
  }

  function RenderQuantityInput(props) {
    const [quantity, setQuantity] = useState(props.row.boxInQuantity);
    const [isReadonly, setIsReadonly] = useState(!props.row.isGenericBox);

    const handleQuantityChange = (event) => {
      setQuantity(event);
      let newDataset = [...boxInQCData];
      var item = newDataset.find((x) => x.boxInId == props.row.boxInId);
      item[props.field] = event;
      setBoxInQCData(newDataset);
    };

    return (
      <CustomInput
        type="number"
        value={quantity}
        setValue={(e) => {
          handleQuantityChange(e);
        }}
        inputCol={12}
        disabled={isReadonly}
        classInput="alignCenter"
      />
    );
  }

  function areDatasetEquals(data1, data2) {
    var data1Json = JSON.stringify(data1);
    var data2Json = JSON.stringify(data2);
    return data1Json == data2Json;
  }

  const handleUploadPhoto = (file, base64, boxInId) => {
    setLoading(true);
    const data = new FormData();
    data.append("file", file);
    var url = `/returnfiles/${idReturnFileHead}/boxinqc/${boxInId}/attachments`;
    axios
      .post(url, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);
        toast.success("Saved!");
        //getDefectDetail(idDefectForQC);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const onSelectFile = (e, boxInId) => {
    var reader = new FileReader();
    reader.onload = function (event) {
      handleUploadPhoto(e.target.files[0], event.target.result.replace("data:image/png;base64,", ""), boxInId);

    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const getColumns = () => {
    setColumns([
      {
        field: "boxInId",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxKO.BoxInId" })}
          />
        ),
        flex: 1.3
      },
      {
        field: "boxInQuantity",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxKO.BoxInQty" })}
          />
        ),
        flex: 1,
        headerAlign: 'center',
        renderCell: RenderQuantityInput,
      },
      {
        field: "boxInLabelling",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxKO.BoxInLabelling" })}
          />
        ),
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: RenderCheckBox,
      },
      {
        field: "boxInDimensions",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxKO.BoxInDimensions" })}
          />
        ),
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: RenderCheckBox,
      },
      {
        field: "boxInWeight",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxKO.BoxInWeight" })}
          />
        ),
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: RenderCheckBox,
      },
      {
        field: "boxInIntegrity",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxKO.BoxInIntegrity" })}
          />
        ),
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: RenderCheckBox,
      },
      {
        field: "boxInContent",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxKO.BoxInContent" })}
          />
        ),
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: RenderCheckBox,
      },
      {
        field: "photoAction",
        type: "actions",
        headerClassName: "grid-header apeLigthBlueBackground whiteText",
        headerName: "Box In Photo",
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => {
          return (
            <>
              <Button
                component="label"
                tabIndex={-1}
                sx={{ pt: 0, color: "#6C6C6C" }}
                className="hideHover"
                startIcon={
                  <AddPhotoAlternateIcon
                    style={{
                      fontSize: 30,
                    }}
                  />
                }
              >
                <input
                  type="file"
                  multiple
                  onInput={(e) => onSelectFile(e, params.row.boxInId)}
                  id="getimage"
                  accept="image/png, image/jpeg"
                ></input>
              </Button>
              <IconButton
                size="large"
                onClick={(e) => handleOpenModalAttachment(e, params.row.boxInId)}
                className="hideHover"
              >
                <FolderOpenOutlinedIcon />
              </IconButton>
            </>
          );
        },
      },
      {
        field: "deleteAction",
        type: "actions",
        headerClassName: "grid-header apeLigthBlueBackground",
        headerName: "",
        flex: 1,
        renderCell: (params) => {
          return (
            <IconButton
              size="large"
              className="hideHover"
              onClick={(e) =>
                handleDeleteRow(
                  params.row.boxInId,
                  params.row.isTemp,
                  params.row.isGenericBox
                )
              }
            >
              <DeleteForeverIcon />
            </IconButton>
          );
        },
      },
    ]);
  };

  return (
    <Box sx={{ overflow: "hidden" }}>
      <PageHeader
        title={
          intl.formatMessage({ id: "RADetails.BoxKO" }) +
          " - " +
          returnFileKey
        }
      />
      <Grid
        container
        style={{ height: "100%" }}
        alignItems="center"
        mt={1}
        mb={1}
      >
        <Grid item md={4} xs={12}>
          <Typography variant="normal">BOX IN</Typography>
        </Grid>
        <Grid item md={2} xs={12} pr={2}>
          <Button
            variant="outlined"
            sx={{ width: "100%" }}
            className="QcBlueButton"
            disabled={scannedBox.Barcode.length == 0}
            onClick={(e) => addRowInBoxIdQCDataset()}
          >
            {intl.formatMessage({ id: "BoxKO.Scan" })}
          </Button>
        </Grid>
        <Grid item md={4} xs={12} pr={2}>
          <TextField
            variant="outlined"
            size="small"
            value={scannedBox.Barcode}
            sx={{ width: "100%" }}
            onChange={(e) => {
              handleBarcodeFilterChange(e.target.value);
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <BarcodeIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item md={2} xs={12}>
          <Button
            variant="outlined"
            sx={{ width: "100%" }}
            className="QcBlueButton"
            disabled={boxGenButtonDisabled}
            onClick={(e) => getGenericBoxId()}
          >
            {intl.formatMessage({ id: "BoxKO.BoxGen" })}
          </Button>
        </Grid>
      </Grid>
      <CustomTable
        columns={columns}
        rows={boxInQCData}
        id={"boxInId"}
        rowHeight={50}
        headerHeight={50}
        tableHeight={420}
      />
      <Grid
        container
        style={{ height: "100%" }}
        alignItems="center"
        mt={1}
        mb={1}
      >
        <Grid item md={2} xs={12}>
          <Button
            variant="outlined"
            sx={{ width: "90%" }}
            onClick={handleGoBack}
          >
            {intl.formatMessage({ id: "BoxKO.Back" })}
          </Button>
        </Grid>
        <Grid item md={2} xs={12}>
          <Button
            variant="outlined"
            sx={{ width: "90%" }}
            onClick={(e) => saveOrUpdateBoxInQC()}
          >
            {intl.formatMessage({ id: "BoxKO.Save" })}
          </Button>
        </Grid>
      </Grid>

      <AttachmentBoxInQCModal
        openModal={openModalAttachmentBoxInQC}
        handleCloseModal={handleCloseModalAttachmentBoxInQC}
        idReturnFileHead={idReturnFileHead}
        boxInId={selectedBoxInId}
        activeAttachment={activeAttachment}
      />
    </Box>
  );
}
